/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  ApplyDirectoryRoleSetupItem,
  ApplyDirectoryRoleSetupItem$Outbound,
  ApplyDirectoryRoleSetupItem$outboundSchema,
} from "./applydirectoryrolesetupitem.js";
import {
  RoleGrant,
  RoleGrant$Outbound,
  RoleGrant$outboundSchema,
} from "./rolegrant.js";

export type ApplyDirectoryRoleSetupForm = {
  /**
   * Optional grants given to every role this request creates. Omit to create roles with no grants. Existing roles are never changed.
   */
  grantSet?: Array<RoleGrant> | undefined;
  /**
   * The sources to set up. Each source may appear once.
   */
  items: Array<ApplyDirectoryRoleSetupItem>;
};

/** @internal */
export type ApplyDirectoryRoleSetupForm$Outbound = {
  grant_set?: Array<RoleGrant$Outbound> | undefined;
  items: Array<ApplyDirectoryRoleSetupItem$Outbound>;
};

/** @internal */
export const ApplyDirectoryRoleSetupForm$outboundSchema: z.ZodMiniType<
  ApplyDirectoryRoleSetupForm$Outbound,
  ApplyDirectoryRoleSetupForm
> = z.pipe(
  z.object({
    grantSet: z.optional(z.array(RoleGrant$outboundSchema)),
    items: z.array(ApplyDirectoryRoleSetupItem$outboundSchema),
  }),
  z.transform((v) => {
    return remap$(v, {
      grantSet: "grant_set",
    });
  }),
);

export function applyDirectoryRoleSetupFormToJSON(
  applyDirectoryRoleSetupForm: ApplyDirectoryRoleSetupForm,
): string {
  return JSON.stringify(
    ApplyDirectoryRoleSetupForm$outboundSchema.parse(
      applyDirectoryRoleSetupForm,
    ),
  );
}
